import React, { useState } from 'react'
import UpgradeActions from './UpgradeActions'
import { Button } from '~/lib/ui/button'
import { Dialog, DialogContent, DialogTrigger } from '~/lib/ui/dialog'
import YnsIcon from '~/components/icons/YnsIcon'
import Features from './Features'
import useTranslation, {
  TranslationProvider,
} from '../shared/TranslationProvider'
import translations from './locales.json'

const PreUpgradeDialogInner = (props) => {
  const { t } = useTranslation('PreUpgradeDialog')
  const { videoUrl, programLevel, open, toggleOpen, platformName } = props

  return (
    <Dialog
      open={open}
      onOpenChange={toggleOpen}
      className="rounded-2xl lg:max-w-[37rem] xl:max-w-[37rem]"
    >
      <DialogTrigger asChild className="cursor-pointer">
        <Button size="sm" className="font-medium">
          {t('upgrade')}
          <YnsIcon name="onboarding-success" className="ml-2" />
        </Button>
      </DialogTrigger>
      <DialogContent
        className="fix-legacy-hack font-robot max-h-[90vh] overflow-y-auto rounded-2xl lg:max-w-3xl xl:max-w-5xl"
        variant="noHeader"
        dialogCloseClass="text-black"
      >
        <div className="flex w-full flex-col font-roboto md:flex-row">
          <div className="flex flex-col gap-4 p-8 pb-0 md:flex-1 md:pb-8">
            <h1 className="!m-0 font-roboto-slab font-medium text-primary">
              {t('new_platform_title', { platformName: platformName })}
            </h1>
            <video
              src={videoUrl}
              autoPlay
              muted
              loop
              controls={false}
              preload="auto"
              className="h-auto w-full md:hidden"
              onLoadedMetadata={(e) => {
                e.target.playbackRate = 2.5
              }}
            />
            <p className="!mb-0 text-lg font-medium">
              {t('new_platform_intro_text')}
            </p>
            <p className="!mb-0 text-lg font-medium">
              {t('new_platform_desc_text')}
            </p>
            <UpgradeActions
              toggleOpen={toggleOpen}
              platformName={platformName}
            />
          </div>
          <div className="col-span-1 flex flex-col gap-4 rounded-br-2xl rounded-tr-2xl p-8 pt-4 md:flex-1 md:bg-intoo-blue-light md:pt-8">
            <video
              src={videoUrl}
              autoPlay
              muted
              loop
              controls={false}
              preload="auto"
              className="hidden h-auto w-full pt-8 md:!visible md:!block"
              onLoadedMetadata={(e) => {
                e.target.playbackRate = 2.5
              }}
            />
            <Features programLevel={programLevel} />
          </div>
        </div>
      </DialogContent>
    </Dialog>
  )
}

const PreUpgradeDialog = ({ videoUrl, locale, programLevel, platformName }) => {
  const [open, setOpen] = useState(false)
  const toggleOpen = () => {
    setOpen(!open)
  }

  return (
    <TranslationProvider
      locale={locale}
      translations={translations}
      scope={'javascript.components.OpNextUpgrade'}
    >
      <PreUpgradeDialogInner
        videoUrl={videoUrl}
        programLevel={programLevel}
        open={open}
        toggleOpen={toggleOpen}
        platformName={platformName}
      />
    </TranslationProvider>
  )
}

export default PreUpgradeDialog
